import { observer } from 'mobx-react-lite'
import { useLocationSettings } from 'app/components/location-settings/useLocationSettings'
import { LocationSettingsShadcnComponent } from 'app/components/location-settings/LocationSettingsShadcnComponent'

// Wrapped in observer so MobX tracks the locationStore.list read inside
// useLocationSettings — otherwise the route never re-renders when the fetch
// resolves and the page is stuck on "Loading…".
export default observer(function LocationsIndex(): React.ReactElement {
  const hookData = useLocationSettings()
  return <LocationSettingsShadcnComponent {...hookData} />
})
